import NotAvailableOnPlan from './NotAvailableOnPlan'

export default NotAvailableOnPlan
